/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/iframe-has-title */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import { Row, Col } from 'antd';

import PropTypes from 'prop-types';
import s from './Footer.css';
import Link from '../Link';
import { version } from '../../../package.json';

const year = new Date();

const labels = {
  eng: {
    faq: 'FAQ',
    contactUs: 'Contact Us...',
    letsConnected: "Let's Connected...",
  },
  ind: {
    faq: 'FAQ',
    contactUs: 'Kontak Kami...',
    letsConnected: 'Mari Terhubung...',
  },
};

export default function Footer(props) {
  useStyles(s);
  const { language = 'ind' } = props.props;
  const { isMobile } = props.props;
  const label = labels[language];

  return (
    <div className={s.root}>
      <div className={s.container}>
        <Row justify="space-between">
          <Col xxl={8} xl={6} span={isMobile ? 24 : 8}>
            <Row>
              <Col span="24" style={{ marginBottom: '10px' }}>
                <Row>
                  <Col xxl={4} xl={8} span={10} className={s.mobileSpan10}>
                    <Link to="/">
                      <div className={s.logoLoyola}>
                        <img
                          src={
                            props.dataHeaderFooter.hfLogoPath
                              ? props.dataHeaderFooter.hfLogoPath
                              : props.logoLoyola.source
                          }
                          alt="logoLoyola"
                          width={isMobile ? 70 : 90}
                          height={isMobile ? 70 : 90}
                        />
                      </div>
                    </Link>
                  </Col>
                  <Col
                    xxl={20}
                    xl={16}
                    span={14}
                    style={{ alignSelf: 'center' }}
                  >
                    <div style={{ width: 190 }}>
                      <span className={s.footerLoyola}>
                        {props.dataHeaderFooter.namaInstitusi ?  props.dataHeaderFooter.namaInstitusi.replace("\\n", '\n') : ''}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Col>
              {isMobile && <Col span={6} className={s.mobileSpan6}></Col>}
              <Col span={isMobile ? 18 : 16} className={s.mobileSpan18}>
                <span className={s.footerAddress}>
                  {props.dataHeaderFooter.hfTelp1} ,{' '}
                  {props.dataHeaderFooter.hfTelp2} <br />
                  {props.dataHeaderFooter.hfAddress} <br />{' '}
                  {props.dataHeaderFooter.hfCity}{' '}
                  {props.dataHeaderFooter.hfPostalCode} <br />
                  {props.dataHeaderFooter.hfProvince}, Indonesia
                </span>
              </Col>
            </Row>
          </Col>
          <Col
            span={isMobile ? 24 : 10}
            style={{ flex: 1, padding: '0em 1em' }}
          >
            <Row gutter={[10, 10]}>
              {/* <Col xxl={24} xl={0} span={0}>
                <div style={{ width: '100%', height: '90px' }} />
              </Col> */}
              <Col span={24} className={s.footerMobile}>
                <div>
                  <Link to="/faq">
                    <span className={s.footerLoyola}>FAQ</span>
                  </Link>
                </div>
                <div className={s.divider} />
              </Col>

              <Col span={isMobile ? 24 : 12} className={s.footerMobile}>
                <div>
                  <span className={s.footerLoyola}>{label.contactUs}</span>
                </div>
                <div className={s.divider} />
                <div>
                  <img
                    alt="Mail"
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyMiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjA1NTMyIDAuMDEwNDk4SDE5LjcyMkMyMC44Njc4IDAuMDEwNDk4IDIxLjgwNTMgMC45NDc5OTggMjEuODA1MyAyLjA5MzgzVjE0LjU5MzhDMjEuODA1MyAxNS43Mzk3IDIwLjg2NzggMTYuNjc3MiAxOS43MjIgMTYuNjc3MkgzLjA1NTMyQzEuOTA5NDggMTYuNjc3MiAwLjk3MTk4NSAxNS43Mzk3IDAuOTcxOTg1IDE0LjU5MzhWMi4wOTM4M0MwLjk3MTk4NSAwLjk0Nzk5OCAxLjkwOTQ4IDAuMDEwNDk4IDMuMDU1MzIgMC4wMTA0OThaTTEyLjQ5MjggOC42OThMMTkuMzA1MyA0LjQzNzU4QzE5LjU2NTcgNC4yNzA5MiAxOS43MjIgMy45ODk2NiAxOS43MjIgMy42ODc1OEMxOS43MjIgMi45ODk2NiAxOC45NjE2IDIuNTczIDE4LjM2NzggMi45Mzc1OEwxMS4zODg3IDcuMzAyMTZMNC40MDk0OCAyLjkzNzU4QzMuODE1NzMgMi41NzMgMy4wNTUzMiAyLjk4OTY2IDMuMDU1MzIgMy42ODc1OEMzLjA1NTMyIDMuOTg5NjYgMy4yMTE1NyA0LjI3MDkyIDMuNDcxOTggNC40Mzc1OEwxMC4yODQ1IDguNjk4QzEwLjk2MTYgOS4xMjUwOCAxMS44MTU3IDkuMTI1MDggMTIuNDkyOCA4LjY5OFoiIGZpbGw9IiNGRkU2MDAiLz4KPC9zdmc+Cg=="
                  />
                  <a
                    href={`https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${props.dataHeaderFooter.hfEmail}`}
                    target="_blank"
                    className={s.sosial}
                  >
                    {props.dataHeaderFooter.hfEmail}
                  </a>
                </div>
                <div>
                  <img
                    alt="WhatsApp"
                    src="data:image/svg+xml;base64,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"
                  />
                  <a
                    target="_blank"
                    href={`https://api.whatsapp.com/send?phone=62${props.dataHeaderFooter.hfWa}`}
                    className={s.sosial}
                  >
                    {props.dataHeaderFooter.hfWa}
                  </a>
                </div>
              </Col>

              <Col span={isMobile ? 24 : 12} className={s.footerMobile}>
                <div>
                  <span className={s.footerLoyola}>{label.letsConnected}</span>
                </div>
                <div className={s.divider} />
                <div>
                  <img
                    alt="Instaram"
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjcxODMgMC41OTU3MDNDNy4wNzkxOSAwLjU5NTcwMyA2Ljc0Nzk4IDAuNjA3MjQzIDUuNzExNDUgMC42NTQ0MTNDNC42NzY5NCAwLjcwMTc4NiAzLjk3MDgxIDAuODY1NTY2IDMuMzUyOTQgMS4xMDU4N0MyLjcxMzgxIDEuMzU0MDcgMi4xNzE2NiAxLjY4NjA5IDEuNjMxNTMgMi4yMjY0MkMxLjA5MDk5IDIuNzY2NTUgMC43NTg5NzYgMy4zMDg3IDAuNTA5OTY2IDMuOTQ3NjNDMC4yNjkwNTMgNC41NjU3IDAuMTA1MDcgNS4yNzIwNCAwLjA1ODUwNzQgNi4zMDYxNEMwLjAxMjE0NjkgNy4zNDI2NyAwIDcuNjc0MDggMCAxMC4zMTMyQzAgMTIuOTUyMyAwLjAxMTc0MjMgMTMuMjgyNSAwLjA1ODcxMDEgMTQuMzE5QzAuMTA2Mjg1IDE1LjM1MzUgMC4yNzAwNjUgMTYuMDU5NyAwLjUxMDE2OCAxNi42Nzc1QzAuNzU4NTcxIDE3LjMxNjcgMS4wOTA1OSAxNy44NTg4IDEuNjMwOTIgMTguMzk4OUMyLjE3MDg1IDE4LjkzOTUgMi43MTMgMTkuMjcyMyAzLjM1MTcyIDE5LjUyMDVDMy45NyAxOS43NjA4IDQuNjc2MzQgMTkuOTI0NiA1LjcxMDY0IDE5Ljk3MkM2Ljc0NzE3IDIwLjAxOTEgNy4wNzgxOCAyMC4wMzA3IDkuNzE3MDggMjAuMDMwN0MxMi4zNTY0IDIwLjAzMDcgMTIuNjg2NiAyMC4wMTkxIDEzLjcyMzEgMTkuOTcyQzE0Ljc1NzYgMTkuOTI0NiAxNS40NjQ2IDE5Ljc2MDggMTYuMDgyOCAxOS41MjA1QzE2LjcyMTggMTkuMjcyMyAxNy4yNjMxIDE4LjkzOTUgMTcuODAzIDE4LjM5ODlDMTguMzQzNiAxNy44NTg4IDE4LjY3NTYgMTcuMzE2NyAxOC45MjQ2IDE2LjY3NzdDMTkuMTYzNSAxNi4wNTk3IDE5LjMyNzUgMTUuMzUzMyAxOS4zNzYxIDE0LjMxOTJDMTkuNDIyNiAxMy4yODI3IDE5LjQzNDggMTIuOTUyMyAxOS40MzQ4IDEwLjMxMzJDMTkuNDM0OCA3LjY3NDA4IDE5LjQyMjYgNy4zNDI4OCAxOS4zNzYxIDYuMzA2MzVDMTkuMzI3NSA1LjI3MTg0IDE5LjE2MzUgNC41NjU3IDE4LjkyNDYgMy45NDc4M0MxOC42NzU2IDMuMzA4NyAxOC4zNDM2IDIuNzY2NTUgMTcuODAzIDIuMjI2NDJDMTcuMjYyNSAxLjY4NTg4IDE2LjcyMiAxLjM1Mzg3IDE2LjA4MjIgMS4xMDU4N0MxNS40NjI3IDAuODY1NTY2IDE0Ljc1NjIgMC43MDE3ODYgMTMuNzIxNyAwLjY1NDQxM0MxMi42ODUyIDAuNjA3MjQzIDEyLjM1NTIgMC41OTU3MDMgOS43MTUyNiAwLjU5NTcwM0g5LjcxODNaTTkuMzk0MTcgMi4zNDY3OEg5LjM5NDQyTDkuNzE4MyAyLjM0Njg4QzEyLjMxMjkgMi4zNDY4OCAxMi42MjA0IDIuMzU2MTkgMTMuNjQ1IDIuNDAyNzVDMTQuNTkyNCAyLjQ0NjA3IDE1LjEwNjYgMi42MDQzOSAxNS40NDkyIDIuNzM3NEMxNS45MDI3IDIuOTEzNTMgMTYuMjI2IDMuMTI0MDcgMTYuNTY1OSAzLjQ2NDE4QzE2LjkwNiAzLjgwNDMgMTcuMTE2NSA0LjEyODIxIDE3LjI5MzEgNC41ODE2OUMxNy40MjYxIDQuOTIzODMgMTcuNTg0NiA1LjQzODA1IDE3LjYyNzcgNi4zODU1QzE3LjY3NDMgNy40MDk4OSAxNy42ODQ0IDcuNzE3NjEgMTcuNjg0NCAxMC4zMTFDMTcuNjg0NCAxMi45MDQzIDE3LjY3NDMgMTMuMjEyIDE3LjYyNzcgMTQuMjM2NEMxNy41ODQ0IDE1LjE4MzkgMTcuNDI2MSAxNS42OTgxIDE3LjI5MzEgMTYuMDQwMkMxNy4xMTY5IDE2LjQ5MzcgMTYuOTA2IDE2LjgxNjYgMTYuNTY1OSAxNy4xNTY1QzE2LjIyNTggMTcuNDk2NiAxNS45MDI5IDE3LjcwNzIgMTUuNDQ5MiAxNy44ODMzQzE1LjEwNyAxOC4wMTY5IDE0LjU5MjQgMTguMTc0OCAxMy42NDUgMTguMjE4MkMxMi42MjA2IDE4LjI2NDcgMTIuMzEyOSAxOC4yNzQ4IDkuNzE4MyAxOC4yNzQ4QzcuMTIzNTIgMTguMjc0OCA2LjgxNjAxIDE4LjI2NDcgNS43OTE2MiAxOC4yMTgyQzQuODQ0MTcgMTguMTc0NCA0LjMyOTk1IDE4LjAxNjEgMy45ODcyMSAxNy44ODMxQzMuNTMzNzIgMTcuNzA3IDMuMjA5ODEgMTcuNDk2NCAyLjg2OTcgMTcuMTU2M0MyLjUyOTU4IDE2LjgxNjIgMi4zMTkwNCAxNi40OTMxIDIuMTQyNSAxNi4wMzk0QzIuMDA5NSAxNS42OTczIDEuODUwOTggMTUuMTgzMSAxLjgwNzg2IDE0LjIzNTZDMS43NjEyOSAxMy4yMTEyIDEuNzUxOTggMTIuOTAzNSAxLjc1MTk4IDEwLjMwODVDMS43NTE5OCA3LjcxMzU2IDEuNzYxMjkgNy40MDc0NiAxLjgwNzg2IDYuMzgzMDdDMS44NTExOCA1LjQzNTYyIDIuMDA5NSA0LjkyMTQgMi4xNDI1IDQuNTc4ODZDMi4zMTg2MyA0LjEyNTM4IDIuNTI5NTggMy44MDE0NiAyLjg2OTcgMy40NjEzNUMzLjIwOTgxIDMuMTIxMjQgMy41MzM3MiAyLjkxMDY5IDMuOTg3MjEgMi43MzQxNkM0LjMyOTc1IDIuNjAwNTQgNC44NDQxNyAyLjQ0MjYzIDUuNzkxNjIgMi4zOTkxMUM2LjY4ODA2IDIuMzU4NjIgNy4wMzU0NiAyLjM0NjQ3IDguODQ2NTUgMi4zNDQ0NVYyLjM0Njg4QzkuMDE1NzMgMi4zNDY2MSA5LjE5NzcxIDIuMzQ2NjkgOS4zOTQxIDIuMzQ2NzhIOS4zOTQxM0g5LjM5NDE3Wk0xNC45MDU0IDMuOTYwMzhDMTQuMjYxNiAzLjk2MDM4IDEzLjczOTMgNC40ODIwOSAxMy43MzkzIDUuMTI2MDhDMTMuNzM5MyA1Ljc2OTg2IDE0LjI2MTYgNi4yOTIxNyAxNC45MDU0IDYuMjkyMTdDMTUuNTQ5MiA2LjI5MjE3IDE2LjA3MTUgNS43Njk4NiAxNi4wNzE1IDUuMTI2MDhDMTYuMDcxNSA0LjQ4MjI5IDE1LjU0OTIgMy45NjAzOCAxNC45MDU0IDMuOTYwMzhaTTkuNzE4MyA1LjMyMjg1QzYuOTYyMzggNS4zMjI4NSA0LjcyNzk2IDcuNTU3MjcgNC43Mjc5NiAxMC4zMTMyQzQuNzI3OTYgMTMuMDY5MSA2Ljk2MjM4IDE1LjMwMjUgOS43MTgzIDE1LjMwMjVDMTIuNDc0MiAxNS4zMDI1IDE0LjcwNzggMTMuMDY5MSAxNC43MDc4IDEwLjMxMzJDMTQuNzA3OCA3LjU1NzI3IDEyLjQ3NDIgNS4zMjI4NSA5LjcxODMgNS4zMjI4NVpNMTIuOTU3NSAxMC4zMTMyQzEyLjk1NzUgOC41MjQxNiAxMS41MDcxIDcuMDc0MDMgOS43MTgzIDcuMDc0MDNDNy45MjkyNyA3LjA3NDAzIDYuNDc5MTMgOC41MjQxNiA2LjQ3OTEzIDEwLjMxMzJDNi40NzkxMyAxMi4xMDIgNy45MjkyNyAxMy41NTIzIDkuNzE4MyAxMy41NTIzQzExLjUwNzEgMTMuNTUyMyAxMi45NTc1IDEyLjEwMiAxMi45NTc1IDEwLjMxMzJaIiBmaWxsPSIjRkZFNjAwIi8+Cjwvc3ZnPgo="
                  />
                  <span className={s.sosial}>
                    <a
                      href={props.dataHeaderFooter.hfInstagramUrl}
                      target="_blank"
                      style={{ color: '#fff' }}
                    >
                      {props.dataHeaderFooter.hfInstagramName}
                    </a>
                  </span>
                </div>
                <div>
                  <img
                    alt="Youtube"
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMS4xOTk3IDIuNzc0ODZDMjAuOTUwNyAxLjgxODI3IDIwLjIxNyAxLjA2NDk5IDE5LjI4NTMgMC44MDkzNDJDMTcuNTk2OSAwLjM0NDcyNyAxMC44MjYxIDAuMzQ0NzI3IDEwLjgyNjEgMC4zNDQ3MjdDMTAuODI2MSAwLjM0NDcyNyA0LjA1NTIzIDAuMzQ0NzI3IDIuMzY2NzMgMC44MDkzNDJDMS40MzUwNyAxLjA2NDk5IDAuNzAxMzU4IDEuODE4MjcgMC40NTIzNTggMi43NzQ4NkMwIDQuNTA4NTcgMCA4LjEyNTk3IDAgOC4xMjU5N0MwIDguMTI1OTcgMCAxMS43NDMyIDAuNDUyMzU4IDEzLjQ3NzFDMC43MDEzNTggMTQuNDMzNyAxLjQzNTA3IDE1LjE4NjkgMi4zNjY3MyAxNS40NDI3QzQuMDU1MjMgMTUuOTA3MiAxMC44MjYxIDE1LjkwNzIgMTAuODI2MSAxNS45MDcyQzEwLjgyNjEgMTUuOTA3MiAxNy41OTY5IDE1LjkwNzIgMTkuMjg1MyAxNS40NDI3QzIwLjIxNyAxNS4xODY5IDIwLjk1MDcgMTQuNDMzNyAyMS4xOTk3IDEzLjQ3NzFDMjEuNjUyMiAxMS43NDMyIDIxLjY1MjIgOC4xMjU5NyAyMS42NTIyIDguMTI1OTdDMjEuNjUyMiA4LjEyNTk3IDIxLjY1MjIgNC41MDg1NyAyMS4xOTk3IDIuNzc0ODZaTTguNzk2ODYgMTEuODQ3MlY1LjA4MDg5TDE0LjIwOTkgOC40NjQxN0w4Ljc5Njg2IDExLjg0NzJaIiBmaWxsPSIjRkZFNjAwIi8+Cjwvc3ZnPgo="
                  />
                  <span className={s.sosial}>
                    <a
                      href={props.dataHeaderFooter.hfYoutube}
                      target="_blank"
                      style={{ color: '#fff' }}
                    >
                      {props.dataHeaderFooter.hfYoutubeName}
                    </a>
                  </span>
                </div>
              </Col>
            </Row>
          </Col>

          <Col
            span={isMobile ? 24 : 6}
            style={{ textAlign: !isMobile && 'center' }}
            className={s.mapsMobile}
          >
            <div>
              {props.dataHeaderFooter.hfMapLong &&
                props.dataHeaderFooter.hfMapLat && (
                  <iframe
                    src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${props.dataHeaderFooter.hfMapLat},${props.dataHeaderFooter.hfMapLong}`}
                    width="250px"
                    height="250px"
                    frameBorder="0"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    aria-hidden="false"
                  />
                )}
            </div>
          </Col>
          <Col span="24" style={{ textAlign: 'center', margin: '20px 0' }}>
            <span className={s.footerAddress}>
              Version {version} Copyright © {year.getFullYear()} Yayasan Loyola
            </span>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Footer.propTypes = {
  dataHeaderFooter: PropTypes.node.isRequired,
  logoBidikti: PropTypes.object.isRequired,
  logoLoyola: PropTypes.object.isRequired,
};
